import { AppLanguage } from "../context/LanguageContext";

function fallbackMessage(language: AppLanguage, input: string) {
  if (!input) return input;
  return input;
}

export function localizeApiMessage(input: string, language: AppLanguage) {
  const message = input?.trim();
  if (!message || language === "en") return message;

  const userAlreadyExists = message.match(/^User with email '(.+)' already exists$/i);
  if (userAlreadyExists) {
    const email = userAlreadyExists[1];
    if (language === "pt-BR") return `Usuário com e-mail '${email}' já existe`;
    if (language === "es") return `El usuario con correo '${email}' ya existe`;
  }

  if (/^User registered successfully$/i.test(message)) {
    if (language === "pt-BR") return "Usuário cadastrado com sucesso";
    if (language === "es") return "Usuario registrado con exito";
  }

  if (/^Invalid token$/i.test(message)) {
    if (language === "pt-BR") return "Token inválido";
    if (language === "es") return "Token invalido";
  }

  if (/^Token expired$/i.test(message)) {
    if (language === "pt-BR") return "Token expirado";
    if (language === "es") return "Token expirado";
  }

  if (/^Password updated successfully$/i.test(message)) {
    if (language === "pt-BR") return "Senha atualizada com sucesso";
    if (language === "es") return "Contrasena actualizada con exito";
  }

  if (/^Success$/i.test(message)) {
    if (language === "pt-BR") return "Sucesso";
    if (language === "es") return "Exito";
  }

  return fallbackMessage(language, message);
}

export function getLocalizedFallback(
  language: AppLanguage,
  options: {
    pt: string;
    es: string;
    en: string;
  }
) {
  if (language === "pt-BR") return options.pt;
  if (language === "es") return options.es;
  return options.en;
}
